const getPageName = () => {
    const segments = new URL(window.location.href).pathname.split("/");
    const last = segments.pop() || segments.pop();
    return last.toLocaleLowerCase();
}

export default getPageName;